import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@core/interfaces/root-state';
import { TableState } from '@core/interfaces/table-state';

import {
  getters as abstract_getters,
  actions as abstract_actions,
  mutations as abstract_mutations,
} from '@core/store/abstract-provider.store';

const state: TableState = {
  models: {},
  // extends with new prop and methods here
};
const getters: GetterTree<TableState, RootState> = {
  ...abstract_getters,
  // extends with new prop and methods here
};
const actions: ActionTree<TableState, RootState> = {
  ...abstract_actions,
  // extends with new prop and methods here
};
const mutations: MutationTree<TableState> = {
  ...abstract_mutations,
  // extends with new prop and methods here
};

export const TableStoreModule: Module<TableState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
